import { object, optional, string } from 'superstruct';

export const benefitsConfigSchema = object({
  benefitsLandingMasonryConfigKey: optional(string()),
  benefitsDetailsMasonryConfigKey: optional(string()),
});
